<template lang="pug">
.compensacao-table
    grid-table-component(:headers='headersAreas', :data='areas', :is-paginated='false')

        template(v-slot:area='{ item }')
            span {{ item.area | decimal }}

        template(v-slot:aprovado='{ item }')
            validacao-component(
                :tipo='item.tipo',
                :item='item',
                :tipos-documentos='tiposDocumentos',
            )

        template(v-slot:acao='{ item }')
            dropdown-component(
                :list='item.acao'
                @input="onAction($event, item)"
                :is-select='false'
                position='left'
            )

    modal-component(
        v-if='areaModalFlag',
        :title='selectedArea.tipo',
        @close='areaModalFlag = false'
        width='45rem'
    )
        ModalVisualizarArea(:area='selectedArea')

    modal-component(
        v-if='exibirWebAmbiente',
        :title='tituloWebAmbiente',
        @close='exibirWebAmbiente = false'
        width='80%'
    )
        SugestaoWebAmbiente(:sugestaoWebAmbiente='sugestaoWebAmbiente', :infoMapa='infoMapa')
</template>

<script>

import ValidacaoComponent from '@/views/analise/components/ValidacaoComponent.vue';
import ModalVisualizarArea from '@/views/analise/components/etapaPRADA/ModalVisualizarArea.vue';
import SugestaoWebAmbiente from '@/views/analise/components/etapaPRADA/SugestaoWebAmbiente.vue';

export default {

    name: 'PradaAreasRecompRegTable',

    components: {
        ValidacaoComponent,
        ModalVisualizarArea,
        SugestaoWebAmbiente
    },

    props: {
        areas: {
            type: Array,
        },

        tiposDocumentos: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {

            headersAreas: [
                { text: 'Projeto', field: 'projeto' },
                { text: 'Área (ha)', field: 'area', width: '70px' },
                { text: 'Ação', field: 'acao' },
                { text: 'Avaliação', field: 'aprovado' },
            ],

            aprovadoOptions: [
                { id: 'APROVADO', label: 'Aprovado' },
                { id: 'REPROVADO', label: 'Reprovado' },
            ],

            areaModalFlag: false,
            selectedArea: null,
            exibirWebAmbiente: false,
            sugestaoWebAmbiente: {},
            tituloWebAmbiente: '',
            infoMapa: {}
        };
    },

    methods: {

        onAction(event, item) {
            if (event.id === 'VISUALIZAR') {
                this.selectedArea = item;
                this.areaModalFlag = true;
            } else if (event.id === 'WEBAMBIENTE') {
                this.sugestaoWebAmbiente = JSON.parse(item.sugestaoWebAmbiente);
                this.sugestaoWebAmbiente.areaTotal = item.area;
                this.sugestaoWebAmbiente.bioma = item.bioma;
                this.tituloWebAmbiente = item.projeto;

                this.montarTokenAcessoMapa(item.projeto);

                this.exibirWebAmbiente = true;
            }
        },
        montarTokenAcessoMapa(projeto) {
            const aderiuPra = this.$route.params?.aderiuPra ? 'COM' : 'SEM';
            const tokenKey = `VUE_APP_TOKEN_MAPA_${projeto}_${aderiuPra}_PRA`;
            this.infoMapa.token = process.env[tokenKey];
            this.infoMapa.codigoArea = `AREA_RECOMPOR_${projeto}_${aderiuPra}_PRA`;
        }
    },
};
</script>
